import { DragEvent, useEffect, useRef } from 'react'
import { Translation } from '@/helpers'

export const OutsiteElementClick = (handler: any) => {
    let refInstance: any = useRef<any>(undefined)

    useEffect(() => {
        let method = (e: any) => !refInstance.current?.contains(e.target) && handler()
        document.addEventListener('mousedown', method)

        return () => document.removeEventListener('mousedown', method)
    })

    return refInstance
}

export const HandleCopy = (component: object, Notification: Function) => {
    try {
        const HandleEvent = function (e: ClipboardEvent) {
            if (e?.clipboardData) {
                const target = 'application/json'
                const data = JSON.stringify(component)

                e.clipboardData.setData(target, data)
                e.preventDefault()
            }

            document.removeEventListener('copy', HandleEvent)
        }

        document.addEventListener('copy', HandleEvent)
        document.execCommand('copy')

        Notification(Translation('component-copy-success'))
    }

    catch (err) {
        Notification(Translation('copied-copy-failed'))
    }
}

export const ImageOnError = (e: any) => {
    const target = e.target as HTMLImageElement
    target.style.display = 'none'
}

export const ScrollTop = () => {
    if (typeof window !== 'undefined') {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }
}

export const ImageOnDrag = (event: DragEvent<HTMLImageElement>) => {
    event.preventDefault()
}
